import {useAuth} from "base/auth";
import {AppMenu} from "base/layout";
import {AccountMenu} from "user/component/presentational";

const MainMenu = () => {
    let auth = useAuth();

    const menuItems = [
        {
            name: "About",
            to: "remap",
            pathname: "remap",
        },
        {
            name: "Map viewer",
            to: "viewer",
            pathname: "",
        },
        {
            name: "Indicators",
            to: "indicators/list",
            pathname: "indicators/list",
        },
    ];

    return (
        <AppMenu menuItems={menuItems}>
            {/*<MainMenuSearch />*/}
            {auth.user && <AccountMenu />}
        </AppMenu>
    );
};

export default MainMenu;
